import axios from '../../../../utils/axios-interceptor';
import { getAPIHost, formatDateYYYYMM } from '../../../../utils/helper';
import { getAccessHeader, getADA, getAll } from '../../../../utils/loginSession';
import { getTealiumCouponRemindersObj } from '../../../../utils/commonService';
import { trackCouponReminders, PAGES } from '../../../../utils/analytics';

export const enums = {
  SET_COUPON_STATE: { type: 'SET_COUPON_STATE', state: 'coupon' }
};

// COMMON FETCH & SET STATE FUNCTIONS -->
export const setState = (type, state) => {
  return {
    type: type.type,
    payload: state,
  };
};

export const fetchState =
  (type, data = {}) =>
    async (dispatch, getState) => {
      try {
        const apiUrl = getAPIHost();
        const login = getAll(getState());
        if (type.url) {
          const res = await axios({
            headers: login.accessHeader,
            method: 'post',
            url: `${apiUrl}/${type.url}`,
            data: data,
          });
          dispatch(setState(type, res.data));
          return res.data;
        } else {
          dispatch(setState(type, data));
        }
      } catch (err) {
        console.log(err);
      }
    };

// Coupon Reminders
export const fetchCouponRemindersState = params => async (dispatch, getState) => {
  try {
    const apiUrl = getAPIHost();
    let res = await axios({
      headers: getAccessHeader(getState()),
      method: 'GET',
      url: `${apiUrl}/couponreminders/reminders`,
      params: {
        aff: params.aff,
        loginAda: getADA(),
        period: formatDateYYYYMM(params.period),
        iterations: params.iterations,
      },
      timeout: 60000,
    });

    // Calling Tealium event
    let couponReminders = getTealiumCouponRemindersObj(res?.data);
    let sortPeriod = formatDateYYYYMM(params.period);
    trackCouponReminders(couponReminders, sortPeriod, { type: PAGES.couponReminders });

    if (res?.data && res?.data?.remindersStatus?.httpStatus == "200") {
      dispatch(setState(enums.SET_COUPON_STATE, { ...res.data }));
      return { ...res.data };
    } else if (res?.data && res?.data?.remindersStatus?.httpStatus == "202") {
      return { ...res.data };
    }
  } catch (err) {
    console.log(err);
    if (err?.code === 'ECONNABORTED') {
      return { status: "timeout" };
    }
  }
};

//Function to send email
export const sendConsentEmail = data => async (dispatch, getState) => {
  try {
    const apiUrl = getAPIHost();
    const res = await axios({
      headers: getAccessHeader(getState()),
      method: 'POST',
      url: `${apiUrl}/couponreminders/sendconsentemail`,
      data: data,
    });
    // console.log("Send Consent Email", res.data);

    return {
      ...res.data,
    };
  } catch (err) {
    console.log(err);
  }
};

// state
const couponState = (state = {}, action) => {
  switch (action.type) {
    // for special case

    // for use enum
    default:
      if (enums[action.type]) {
        return {
          ...state,
          [enums[action.type].state]: action.payload,
        };
      }

      // for default
      return state;
  }
};

export default {
  couponState,
};
